import { SENDBIRD_INFO } from "../helpers/constant";
import { toastError } from "../helpers/methods";

const removeDataOnAssignedChat = async (channel, cb, activeTab = null, currentUser) => {
  try {
    if (!channel || !channel.url) throw new Error("Invalid channel");
    const dataParams =
      activeTab === "tab1"
        ? { data: JSON.stringify({ ArchivedBy: currentUser?.userId }) }
        : {};

    // Step 1: Get the single unhide user
    const unHideUser = channel.members.find((x) => x.userId.startsWith("PA"));
    console.log("Archive unHideUser:", unHideUser);

    // Step 2: Update channel metadata
    const updateResponse = await fetch(
      `https://api-${SENDBIRD_INFO.appId}.sendbird.com/v3/group_channels/${channel.url}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Api-Token": SENDBIRD_INFO.sendBirdToken,
        },
        body: JSON.stringify(dataParams),
      }
    );

    if (!updateResponse.ok) throw new Error("Failed to update channel data");

    // Step 3: Hide all members in one go
    const hideAllResponse = await fetch(
      `https://api-${SENDBIRD_INFO.appId}.sendbird.com/v3/group_channels/${channel.url}/hide`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Api-Token": SENDBIRD_INFO.sendBirdToken,
        },
        body: JSON.stringify({
          should_hide_all: true,
          allow_auto_unhide: true, // keep true for archive flow
        }),
      }
    );

    if (!hideAllResponse.ok) throw new Error("Failed to hide all users");

    // Step 4: Unhide the one provider user
    if (unHideUser) {
      const unhideResponse = await fetch(
        `https://api-${SENDBIRD_INFO.appId}.sendbird.com/v3/group_channels/${channel.url}/hide`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "Api-Token": SENDBIRD_INFO.sendBirdToken,
          },
          body: JSON.stringify({ user_id: unHideUser.userId }),
        }
      );

      if (!unhideResponse.ok) {
        console.warn(`Failed to unhide ${unHideUser.userId}`);
      }
    }

    cb?.(); 
  } catch (error) {
    console.error("Error in removeDataOnAssignedChat:", error);
    toastError("Something went wrong while archiving chat");
  }
};

export default removeDataOnAssignedChat;

